import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { companyRolesActions } from '../reducer';

export default (value) => companyRolesActions[SET_IS_OPEN_MODAL](value);
